import globalConfig from './globalConfig';

/** 无特例 gameId 时，gabres/octlib 使用 defaultAvatar.png */
export const DEFAULT_PLATFORM_ICON_IMAGE_NAME = 'defaultAvatar';

/** 定制化处理的个人中心头像（需要在resource_gabres.37games.com\dist\platformIcon中上传） */
const CUSTOM_PLATFORM_ICON_HOSTS = new Set([
  atob('M3N5dWEuY29t'), // 3syua.com
  atob('MzdnYW1lcy5jb20='), // 37games.com
  atob('ZGNxdm4uY29t'), // dcqvn.com
  atob('YmxhbmNvem9uZS5jb20='), // blancozone.com
  atob('Z2FtZW1hcnQudm4='), // gamemart.vn
  atob('bW9yZWZ1bmdyb3Vwcy5jb20='), // morefungroups.com
  atob('b21uaWthZGUuY29t'), // omnikade.com
  atob('cGxheXBsYW5ldGdhbWUuY29t'), // playplanetgame.com
  atob('cG5zb2ZmaWNpYWwuY29t'), // pnsofficial.com
  atob('dGhpZW50aHVvbmdob2EuY29t'), // thienthuonghoa.com
  atob('dHRoZ2FtZS5jb20='), // tthgame.com
  atob('dmdtLnZu'), // vgm.vn
]);

/**
 * 默认分支（非 getImageName 特例 gameId）下的 CDN 文件名
 */
export function getHostDefaultPlatformIconImageName() {
  const mainHost = globalConfig.getMainHost();

  if (CUSTOM_PLATFORM_ICON_HOSTS.has(mainHost)) {
    return mainHost;
  }

  return DEFAULT_PLATFORM_ICON_IMAGE_NAME;
}
